// extracted by mini-css-extract-plugin
module.exports = {"input":"RoyaltyAddress_input__3H582"};